// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"placeholder__2jpDP1wSpPtr"};